import { Alert, Snackbar } from '@mui/material';
import React, {
  FunctionComponent,
  PropsWithChildren,
  useCallback,
  useState,
} from 'react';

import { Toast, ToastContext } from './Toast.context';

export const ToastProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [toast, setToast] = useState<Toast | null>(null);

  const showToast = useCallback((toastValue: Toast) => {
    setToast(toastValue);
    setIsVisible(true);
  }, []);

  const onClose = useCallback(() => {
    setIsVisible(false);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Snackbar
        open={isVisible}
        onClose={onClose}
        autoHideDuration={toast?.type === 'error' ? null : 2000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={onClose}
          severity={toast?.type}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {toast?.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
};
